import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement } from '@nosto/preact'
import { defaultConfig } from '../config'
import { useEffect, useState, useMemo } from 'preact/hooks'
import { formatCurrency, currency, formatPriceWithoutDecimal, updateImageUrl } from '../helpers'

import Badges from '../serp/Badges'

export default () => {
    const {
        response: { products },
    } = useAppState()

    const [worldPrices, setWorldPrices] = useState({})
    const isWorldStore = location.hostname === 'www.dvf.com'
    const isMobile = window.innerWidth < 769

    // Memoize currency symbol lookup
    const currencySymbol = useMemo(() => {
        if (!isWorldStore) return null

        const currency_symbols = {
            AED: 'د.إ',
            AFN: '؋',
            ALL: 'L',
            AMD: '֏',
            ANG: 'ƒ',
            AOA: 'Kz',
            ARS: '$',
            AUD: '$',
            AWG: 'Afl ',
            AZN: '₼',
            BAM: 'KM',
            BBD: '$',
            BDT: '৳',
            BGN: 'лв',
            BHD: '.د.ب',
            BIF: 'FBu',
            BMD: '$',
            BND: '$',
            BOB: '$b',
            BOV: 'BOV',
            BRL: 'R$',
            BSD: '$',
            BTC: '₿',
            BTN: 'Nu.',
            BWP: 'P',
            BYN: 'Br',
            BYR: 'Br',
            BZD: 'BZ$',
            CAD: '$',
            CDF: 'FC',
            CHE: 'CHE',
            CHF: 'CHF',
            CHW: 'CHW',
            CLF: 'CLF',
            CLP: '$',
            CNH: '¥',
            CNY: '¥',
            COP: '$',
            COU: 'COU',
            CRC: '₡',
            CUC: '$',
            CUP: '₱',
            CVE: '$',
            CZK: 'Kč',
            DJF: 'Fdj',
            DKK: 'kr',
            DOP: 'RD$',
            DZD: 'دج',
            EEK: 'kr',
            EGP: '£',
            ERN: 'Nfk',
            ETB: 'Br',
            ETH: 'Ξ',
            EUR: '€',
            FJD: '$',
            FKP: '£',
            GBP: '£',
            GEL: '₾',
            GGP: '£',
            GHC: '₵',
            GHS: 'GH₵',
            GIP: '£',
            GMD: 'D',
            GNF: 'FG',
            GTQ: 'Q',
            GYD: '$',
            HKD: '$',
            HNL: 'L',
            HRK: 'kn',
            HTG: 'G',
            HUF: 'Ft',
            IDR: 'Rp',
            ILS: '₪',
            IMP: '£',
            INR: '₹',
            IQD: 'ع.د',
            IRR: '﷼',
            ISK: 'kr',
            JEP: '£',
            JMD: 'J$',
            JOD: 'JD',
            JPY: '¥',
            KES: 'KSh',
            KGS: 'лв',
            KHR: '៛',
            KMF: 'CF',
            KPW: '₩',
            KRW: '₩',
            KWD: 'KD',
            KYD: '$',
            KZT: '₸',
            LAK: '₭',
            LBP: '£',
            LKR: '₨',
            LRD: '$',
            LSL: 'M',
            LTC: 'Ł',
            LTL: 'Lt',
            LVL: 'Ls',
            LYD: 'LD',
            MAD: 'MAD',
            MDL: 'lei',
            MGA: 'Ar',
            MKD: 'ден',
            MMK: 'K',
            MNT: '₮',
            MOP: 'MOP$',
            MRO: 'UM',
            MRU: 'UM',
            MUR: '₨',
            MVR: 'Rf',
            MWK: 'MK',
            MXN: '$',
            MXV: 'MXV',
            MYR: 'RM',
            MZN: 'MT',
            NAD: '$',
            NGN: '₦',
            NIO: 'C$',
            NOK: 'kr',
            NPR: '₨',
            NZD: '$',
            OMR: '﷼',
            PAB: 'B/.',
            PEN: 'S/.',
            PGK: 'K',
            PHP: '₱',
            PKR: '₨',
            PLN: 'zł',
            PYG: 'Gs',
            QAR: '﷼',
            RMB: '￥',
            RON: 'lei',
            RSD: 'Дин.',
            RUB: '₽',
            RWF: 'R₣',
            SAR: '﷼',
            SBD: '$',
            SCR: '₨',
            SDG: 'ج.س.',
            SEK: 'kr',
            SGD: 'S$',
            SHP: '£',
            SLL: 'Le',
            SOS: 'S',
            SRD: '$',
            SSP: '£',
            STD: 'Db',
            STN: 'Db',
            SVC: '$',
            SYP: '£',
            SZL: 'E',
            THB: '฿',
            TJS: 'SM',
            TMT: 'T',
            TND: 'د.ت',
            TOP: 'T$',
            TRL: '₤',
            TRY: '₺',
            TTD: 'TT$',
            TVD: '$',
            TWD: 'NT$',
            TZS: 'TSh',
            UAH: '₴',
            UGX: 'USh',
            USD: '$',
            UYI: 'UYI',
            UYU: '$U',
            UYW: 'UYW',
            UZS: 'лв',
            VEF: 'Bs',
            VES: 'Bs.S',
            VND: '₫',
            VUV: 'VT',
            WST: 'WS$',
            XAF: 'FCFA',
            XBT: 'Ƀ',
            XCD: '$',
            XOF: 'CFA',
            XPF: '₣',
            XSU: 'Sucre',
            XUA: 'XUA',
            YER: '﷼',
            ZAR: 'R',
            ZMW: 'ZK',
            ZWD: 'Z$',
            ZWL: '$',
        }

        return currency_symbols[Shopify.currency.active] || Shopify.currency.active
    }, [isWorldStore])

    // Batch fetch all prices at once
    useEffect(() => {
        if (!isWorldStore || !products?.hits?.length) return

        const handles = products.hits
            .slice(0, defaultConfig.autocompleteSize)
            .map((hit) => hit.url.split('products/')[1])
            .filter(Boolean)

        // Create promises for all fetch requests
        const pricePromises = handles.map((handle) =>
            fetch(Shopify.routes.root + 'products/' + handle + '.js')
                .then((response) => response.json())
                .then((data) => ({
                    handle,
                    price: data.price || data.price_max,
                    comparePrice: data.compare_at_price || data.compare_at_price_max,
                }))
                .catch(() => ({ handle, price: null, comparePrice: null }))
        )

        // Execute all requests in parallel
        Promise.all(pricePromises).then((results) => {
            const priceData = {}
            results.forEach(({ handle, price, comparePrice }) => {
                if (price) {
                    const formattedPrice = (price / 100).toFixed(2)
                    const formattedComparePrice =
                        comparePrice && comparePrice !== 0 ? (comparePrice / 100).toFixed(2) : null

                    priceData[handle] = {
                        price: `${currencySymbol}${formatPriceWithoutDecimal(formattedPrice)}`,
                        listPrice: formattedComparePrice
                            ? `${currencySymbol}${formatPriceWithoutDecimal(formattedComparePrice)}`
                            : null,
                    }
                }
            })
            setWorldPrices(priceData)
        })
    }, [products?.hits, isWorldStore, currencySymbol])

    if (!products?.hits?.length) {
        return
    }

    const handleClick = () => {
        document.querySelector('.search-popdown__close__button')?.click()
    }

    return (
        <div class='ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box'>
            <div class='ns-w-100 ns-mt-2 ns-mt-sm-auto'>
                <div class='ns-product-heading'>
                    <span class='ns-results'>{products?.total} results</span>
                    <button
                        type='submit'
                        class='ns-act-btn ns-d-inline-flex ns-align-items-center ns-text-align-center'
                        onClick={handleClick}>
                        View All
                    </button>
                </div>
                <div class='ns-products-list ns-mt-2 ns-mb-2'>
                    {products?.hits?.slice(0, defaultConfig.autocompleteSize)?.map((hit) => {
                        const handle = hit?.url.split('products/')[1]
                        const {
                            url,
                            imageUrl,
                            name,
                            listPrice,
                            price,
                            alternateImageUrls,
                            tags1,
                            categories,
                            availability,
                            customFields,
                        } = hit

                        const worldPriceData = worldPrices[handle]

                        return (
                            <AutocompleteElement hit={hit}>
                                <div data-url={url} class='ns-product ns-d-flex flex-row ns-clickable'>
                                    <a href='javascript:void(0)' class='ns-relative'>
                                        <img
                                            class='ns-h-auto ns-object-contain'
                                            src={
                                                alternateImageUrls
                                                    ? alternateImageUrls[3]
                                                        ? updateImageUrl(alternateImageUrls[3])
                                                        : updateImageUrl(
                                                              alternateImageUrls[alternateImageUrls.length - 1]
                                                          )
                                                    : updateImageUrl(imageUrl)
                                            }
                                            alt={name}
                                        />
                                        <Badges
                                            tags1={tags1}
                                            categories={categories}
                                            availability={availability}
                                            product={hit}
                                            customFields={customFields}
                                        />
                                    </a>
                                    <div>
                                        <div class='ns-font-4 ns-clipped ns-text-one-line ns-prod-name'>{name}</div>
                                        <div>
                                            {listPrice !== price ? (
                                                <>
                                                    <span style='color: red; font-size: .85rem;'>
                                                        {!isWorldStore
                                                            ? `${currency}${formatPriceWithoutDecimal(price)}`
                                                            : worldPriceData?.price ||
                                                              `${currency}${formatPriceWithoutDecimal(price)}`}
                                                    </span>
                                                    <span
                                                        class='ns-font-4 ns-text-striked ns-ml-2'
                                                        style='font-size: .85rem;'>
                                                        {!isWorldStore
                                                            ? `${currency}${formatPriceWithoutDecimal(listPrice)}`
                                                            : worldPriceData?.listPrice ||
                                                              `${currency}${formatPriceWithoutDecimal(listPrice)}`}
                                                    </span>
                                                </>
                                            ) : (
                                                <span style='font-size: .85rem;'>
                                                    {!isWorldStore
                                                        ? `${currency}${formatPriceWithoutDecimal(price)}`
                                                        : worldPriceData?.price ||
                                                          `${currency}${formatPriceWithoutDecimal(price)}`}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </AutocompleteElement>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
